import $ from 'jquery';
import product from '@wc-stripe/product';
import {parsePrice, toCents} from '@wc-stripe/utils';

$(() => {
    const el = document.querySelector('#prad_option_total_price');
    if (!el) return;

    new MutationObserver(() => {
        const price = parsePrice(el.textContent);
        const total = price * product.getQuantity();
        if (total !== null) {
            const update = {total, price};
            const lineItem = product.getLineItem();
            if (lineItem) {
                update.lineItems = product.getLineItems().map(item =>
                    item.id === lineItem.id
                        ? {...item, amount: total, amountCents: toCents(total)}
                        : item
                );
            }
            product.update(update);
        }
    }).observe(el, {childList: true, characterData: true, subtree: true});
});